import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from 'app/core/user/user.service';

export const LockedGuard: CanActivateFn | CanActivateChildFn = (
	route,
	state
) => {
	const userService = inject(UserService);
	const router = inject(Router);

	const guardFn = () => {
		if (userService.hasPermission('setting:billing')) {
			if (state.url.includes('settings/plan-billing')) {
				return true;
			}

			return router.createUrlTree(['/settings/plan-billing']);
		}

		return router.createUrlTree(['/sign-out']);
	};

	const user = userService.userSig$();

	if (!user) {
		return true;
	}

	if (user.isLocked) {
		return guardFn();
	}

	return true;
};
